import axios from "axios";
import pMemoize from "p-memoize";
import vueStore from "@/store";

// Load env.json from domain root, for both customer-root & customer-sba
let ENV_FILE_PATH = "/env.json";

let APP_VAR;

export async function getAppCustomEnv() {

  try {
    if (process.env.NODE_ENV === "development") {
      const platformConfig = vueStore.state.configModule.platformConfig;
      const tenantName = platformConfig.tenant;
      ENV_FILE_PATH = `/env.${tenantName}.local.json`;
      let response = await axios.get(ENV_FILE_PATH);
      let data = JSON.parse(JSON.stringify(response.data));
      APP_VAR = data;
      return data;
    }
  } catch (error) {
    console.log("Revert back in using /env.json since env.<tenant>.local.json is not found copy paste to public if you want QOL update", error);
    ENV_FILE_PATH = "/env.json";
  }


  if (APP_VAR && APP_VAR.VUE_APP_BUILD_NUMBER === sessionStorage.getItem("lastKnownBuildVersion")) {
    return APP_VAR;
  } else {
    let response = await axios.get(ENV_FILE_PATH);
    if (response.status < 400) {
      let data = JSON.parse(JSON.stringify(response.data));
      APP_VAR = data;
      return data;
    }
  }
}

export default pMemoize(getAppCustomEnv);
